<template>
    <div>
        <h3 v-if="title">{{title}}</h3>
        <h5 v-if="description"> <span v-html="description"></span></h5>
        <img v-if="image" style='width: 100%;padding-bottom: 20px' v-bind:src="image" class='img-fluid'/>
        <h5 v-if="description2"> <span v-html="description2"></span></h5>
    </div>
</template>

<script>
    export default {
        name: "TitleContentImagesComponent",
        props: {
            title: String,
            description: String,
            description2: String,
            image: Array
        }
    }
</script>

<style scoped>
    h5 {
        padding-bottom: 20px;
    }

</style>
